import showSavedJobsCountAnimation from "./show-saved-jobs-count-animation";

const showSavedJobsCount = (config = {}) => {
	const onload = config.onload || false;
	const savedJobsLocalstorage = localStorage.getItem(`careerSavedJobsID_${lang}`);
	const savedJobsCount = savedJobsLocalstorage ? JSON.parse(savedJobsLocalstorage).length : 0;
	const saveJobsCountHtml = `<div class="saved-jobs-items">${savedJobsCount}</div>`;
	const saveJobsElement = '[data-nav-element-type="saved-jobs-link"]';
	const mainNavItem = document.querySelector(`${saveJobsElement} a`);

	if(savedJobsCount === 0 && !onload) {
		if(mainNavItem) {
			mainNavItem.classList.remove('saved-jobs-items-added');
		}

		showSavedJobsCountAnimation({
			show: false,
			complete: () => {
				if(mainNavItem) {
					mainNavItem.removeChild(document.querySelector(`${saveJobsElement} a .saved-jobs-items`));
				}
			}
		});
	}

	if(mainNavItem && savedJobsCount >= 1) {
		const savedJobsTotalItems = document.querySelector('.saved-jobs-items');

		if(onload) {
			if(!savedJobsTotalItems) {
				mainNavItem.innerHTML = `${mainNavItem.innerHTML} ${saveJobsCountHtml}`;
				mainNavItem.classList.add('saved-jobs-items-added');
			}

			return;
		}

		if(savedJobsTotalItems) {
			savedJobsTotalItems.innerHTML = savedJobsCount;
		} else {
			mainNavItem.innerHTML = `${mainNavItem.innerHTML} ${saveJobsCountHtml}`;
			mainNavItem.classList.add('saved-jobs-items-added');

			const savedJobsTotalItems = document.querySelector('.saved-jobs-items');

			savedJobsTotalItems.innerHTML = savedJobsCount;
		}
	}


};

export default showSavedJobsCount;